<template>
  <div class="experience-card">
    <img v-if="showImage" :src="pic" alt="website capture"
      class="z-10 absolute w-100 shadow-2xl mx-24 my-10 rounded-xl">
      <div class="w-4/5 flex-1 flex flex-col justify-between">
        <div>
          <div class="flex flex-row items-start space-x-2 leading-relaxed">
            <div class="h-8 w-8 4k:h-14 4k:w-14 animate-bounce
            text-summer-lilac dark:text-summer-yellow"
              @mouseover="showImage = true" @mouseleave="showImage = false">
              <IconImage />
            </div>
            <h1 class="text-base sm:text-xl fhd:text-2xl 4k:text-5xl uppercase">{{ title }}</h1>
          </div>
          <p class="text-xs fhd:text-sm 4k:text-3xl font-mono">{{ date }}</p>
        </div>
        <p class="text-base sm:text-base fhd:text-xl 4k:text-4xl my-4 fhd:my-6">
          {{ description }}
        </p>
        <div class="flex font-mono text-xs fhd:text-sm 4k:text-3xl flex-wrap">
          <p v-for="(item, index) in listLang" :key="index"
            class="m-1 px-2 py-1 4k:m-2 4k:px-4 4k:py-3 rounded-full
            bg-pink-100 dark:text-gray-900">
            {{ item }}
          </p>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  props: {
    pic: { type: String, default: 'https://firebasestorage.googleapis.com/v0/b/portfolio-kaysoohyun.appspot.com/o/notimage.png?alt=media&token=8a96d54a-d227-4fae-83ea-07aac2146b6f' },
    title: { type: String, default: '' },
    date: { type: String, default: '' },
    description: { type: String, default: '' },
    listLang: { type: Array, default: () => [] },
  },
  data() {
    return {
      showImage: false,
    }
  }
}
</script>
